// BL CUSTOM DEV
const addSRLabelForStarRating = () => {
  const targetNode = document.querySelector('.stamped-product-reviews-badge');

  const config = { attributes: false, childList: true, subtree: false };

  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // console.log('[monitorDomChanges] A childList was added or removed.');

        const productRating = targetNode.querySelector('.stamped-badge')?.dataset.rating;
        if (productRating) {
          observer.disconnect();
          // console.log('[monitorDomChanges]', { productRating });
          let textContent = `${productRating} out of 5.0 stars`
          if (productRating === '0.0') {
            textContent = 'No reviews for this product yet';
          }

          const srLabel = document.createElement('span');
          srLabel.className = 'sr-only';
          srLabel.textContent = textContent;
          targetNode.querySelector('.stamped-starrating').insertAdjacentElement('beforebegin', srLabel);
        }

      }
    }
  };

  if (targetNode === null) return;

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
};

const addSRLabelToSwatchVariants = () => {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantPickerInitialized, ({ data }) => {
    // console.log('[addSRLabelToSwatchVariants] variantOptions', data.variantOptions);

    data.variantOptions.forEach(variantOption => {
      const value = variantOption.getAttribute('value')

      // console.log({ value, classList: variantOption.classList })
      if (variantOption.classList.contains('disabled')) {
        // console.log(`[addSRLabelToSwatchVariants] ${value} - Sold Out`);
        variantOption.setAttribute('aria-label', `${value} - Sold Out`);
      } else {
        // console.log(`[addSRLabelToSwatchVariants] ${value} - Available`);
        variantOption.setAttribute('aria-label', value);
      }
    })

  });
};

const initCustom = () => {
  addSRLabelForStarRating();
  addSRLabelToSwatchVariants();
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  initCustom();
} else {
  document.addEventListener('DOMContentLoaded', initCustom);
}